var _circle, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _circle2, _rect3, _rect4, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardSponsor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 130,
    viewBox: "0 0 138 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 65,
    r: 63,
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8748 20C47.0839 20 48.8747 21.7908 48.8748 23.9999L48.8748 28.6606H97.2673C97.8196 28.6606 98.2673 29.1083 98.2673 29.6605L98.2676 88.2576C98.2676 88.8202 97.8036 89.2721 97.2411 89.2572L17.4134 87.145C16.8716 87.1307 16.4398 86.6874 16.4398 86.1454V29.6606C16.4398 29.1083 16.8875 28.6606 17.4398 28.6606H15.0003V24C15.0003 21.7909 16.7912 20 19.0003 20H44.8748Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8748 23.9999L50.8748 23.9999V23.9999L48.8748 23.9999ZM48.8748 28.6606V30.6606H46.8749L46.8748 28.6606L48.8748 28.6606ZM98.2673 29.6605L100.267 29.6605L98.2673 29.6605ZM98.2676 88.2576L96.2676 88.2576V88.2576L98.2676 88.2576ZM97.2411 89.2572L97.294 87.2579H97.294L97.2411 89.2572ZM17.4134 87.145L17.4663 85.1457L17.4134 87.145ZM15.0003 28.6606V30.6606H13.0003V28.6606H15.0003ZM46.8748 24C46.8747 22.8954 45.9793 22 44.8748 22V18C48.1884 18 50.8747 20.6862 50.8748 23.9999L46.8748 24ZM46.8748 28.6606L46.8748 24L50.8748 23.9999L50.8748 28.6605L46.8748 28.6606ZM97.2673 30.6606H48.8748V26.6606H97.2673V30.6606ZM96.2673 29.6606C96.2673 30.2128 96.7151 30.6606 97.2673 30.6606V26.6606C98.9242 26.6606 100.267 28.0037 100.267 29.6605L96.2673 29.6606ZM96.2676 88.2576L96.2673 29.6606L100.267 29.6605L100.268 88.2576L96.2676 88.2576ZM97.294 87.2579C96.7316 87.2431 96.2676 87.6949 96.2676 88.2576L100.268 88.2576C100.268 89.9455 98.8756 91.3012 97.1882 91.2565L97.294 87.2579ZM17.4663 85.1457L97.294 87.2579L97.1882 91.2565L17.3605 89.1443L17.4663 85.1457ZM18.4398 86.1454C18.4398 85.6034 18.0081 85.1601 17.4663 85.1457L17.3605 89.1443C15.7351 89.1013 14.4398 87.7713 14.4398 86.1454H18.4398ZM18.4398 29.6606V86.1454H14.4398V29.6606H18.4398ZM17.4398 30.6606C17.9921 30.6606 18.4398 30.2128 18.4398 29.6606H14.4398C14.4398 28.0037 15.783 26.6606 17.4398 26.6606V30.6606ZM15.0003 26.6606H17.4398V30.6606H15.0003V26.6606ZM17.0003 24V28.6606H13.0003V24H17.0003ZM19.0003 22C17.8958 22 17.0003 22.8954 17.0003 24H13.0003C13.0003 20.6863 15.6866 18 19.0003 18V22ZM44.8748 22H19.0003V18H44.8748V22Z",
    fill: "#4D4D4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.5781,
    y: 50.4128,
    width: 84.4404,
    height: 42.2202,
    rx: 1,
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 45,
    width: 83.3578,
    height: 42.2202,
    rx: 1,
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3672 53.6606V79.6422",
    stroke: "#F2463A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.862 53.6606V79.6422",
    stroke: "#F2463A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00009 30C3.71892 30 1.89965 31.9047 2.0043 34.1835L2.20989 38.6606L2.20974 38.6606L4.91014 91.2989C4.93742 91.8306 5.37645 92.2477 5.90882 92.2477H93.7594C94.3318 92.2477 94.7874 91.7681 94.7581 91.1965L92.1116 39.6093C92.0844 39.0776 91.6453 38.6606 91.1129 38.6606L36.8521 38.6606L36.4077 33.6468C36.2247 31.5827 34.4956 30 32.4233 30H6.00009Z",
    fill: "#F4F4F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0043 34.1835L4.00219 34.0917L2.0043 34.1835ZM2.20989 38.6606L2.22245 40.6605L4.30324 40.6474L4.20779 38.5688L2.20989 38.6606ZM2.20974 38.6606L2.19718 36.6606L0.105184 36.6737L0.212366 38.763L2.20974 38.6606ZM4.91014 91.2989L6.90752 91.1965L4.91014 91.2989ZM94.7581 91.1965L92.7607 91.2989V91.2989L94.7581 91.1965ZM92.1116 39.6093L90.1143 39.7118V39.7118L92.1116 39.6093ZM91.1129 38.6606V40.6606V38.6606ZM36.8521 38.6606L34.8599 38.8371L35.0215 40.6606H36.8521V38.6606ZM36.4077 33.6468L38.3999 33.4702V33.4702L36.4077 33.6468ZM4.00219 34.0917C3.94987 32.9524 4.8595 32 6.00009 32V28C2.57833 28 -0.150562 30.8571 0.00640416 34.2752L4.00219 34.0917ZM4.20779 38.5688L4.00219 34.0917L0.00640416 34.2752L0.211997 38.7523L4.20779 38.5688ZM2.2223 40.6605L2.22245 40.6605L2.19733 36.6606L2.19718 36.6606L2.2223 40.6605ZM6.90752 91.1965L4.20711 38.5581L0.212366 38.763L2.91277 91.4014L6.90752 91.1965ZM5.90882 90.2477C6.44121 90.2477 6.88024 90.6648 6.90752 91.1965L2.91277 91.4014C2.99459 92.9964 4.31169 94.2477 5.90882 94.2477V90.2477ZM93.7594 90.2477H5.90882V94.2477H93.7594V90.2477ZM92.7607 91.2989C92.7314 90.7273 93.187 90.2477 93.7594 90.2477V94.2477C95.4767 94.2477 96.8435 92.809 96.7555 91.094L92.7607 91.2989ZM90.1143 39.7118L92.7607 91.2989L96.7555 91.094L94.109 39.5069L90.1143 39.7118ZM91.1129 40.6606C90.5806 40.6606 90.1415 40.2435 90.1143 39.7118L94.109 39.5069C94.0272 37.9118 92.7101 36.6606 91.1129 36.6606V40.6606ZM36.8521 40.6606L91.1129 40.6606V36.6606L36.8521 36.6606V40.6606ZM34.4155 33.8234L34.8599 38.8371L38.8443 38.484L38.3999 33.4702L34.4155 33.8234ZM32.4233 32C33.4594 32 34.324 32.7913 34.4155 33.8234L38.3999 33.4702C38.1254 30.374 35.5317 28 32.4233 28V32ZM6.00009 32H32.4233V28H6.00009V32Z",
    fill: "#4D4D4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5029 37.578H27.824",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 95,
    r: 30,
    fill: "#F2463A",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 112.628,
    y: 77.4476,
    width: 11.3773,
    height: 34.1319,
    rx: 1.42216,
    transform: "rotate(45 112.628 77.4476)",
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 2.84433
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.136,
    y: 77,
    width: 11.3773,
    height: 10.5265,
    rx: 1.42216,
    transform: "rotate(45 113.136 77)",
    stroke: "#4D4D4D",
    strokeWidth: 2.84433
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.078 112.69C86.0509 113.068 85.0523 112.07 85.4303 111.043L88.5291 102.624L95.4963 109.591L87.078 112.69Z",
    fill: "#F4F4F4",
    stroke: "#4D4D4D",
    strokeWidth: 2.84433
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5098 109.818L89.0764 112.385",
    stroke: "#4D4D4D",
    strokeWidth: 2.56668
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.091 84.9897L113.633 92.5319",
    stroke: "#4D4D4D",
    strokeWidth: 2.84433
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSponsor);
export default __webpack_public_path__ + "static/media/dashboard-sponsor.0f2bd6f58094c02ae5a2e6e8831cc513.svg";
export { ForwardRef as ReactComponent };